import { Box, Button, Collapse, Typography } from '@material-ui/core';

const TransitionHeader = ({
  headingLabel,
  buttonLabel,
  headingValue,
  classes,
  fadeIn,
  name,
  clickHandler,
}) => (
  <Box>
    <Collapse in={!fadeIn}>
      <Box className={classes.boxInnerContainer}>
        <Box>
          <Typography className={classes.heading}>{headingLabel}</Typography>
          <Typography variant="body2">{headingValue}</Typography>
        </Box>
        <Button
          className={classes.baseButtoNode}
          data-testid={`transition-click-${name}`}
          onClick={() => clickHandler(name)}
          disableRipple
          disableFocusRipple
          size="small"
          style={{ padding: '0px', backgroundColor: 'unset' }}
        >
          <Typography className={classes.buttonNode}>{buttonLabel}</Typography>
        </Button>
      </Box>
    </Collapse>
  </Box>
);

export default TransitionHeader;
